// extracted by mini-css-extract-plugin
export default {"wrapper":"_c2d768ec","header":"_c8451980","wrapperSpacing":"_8f70aa6d","button":"_79fc1e49"};